import { PayloadAction } from "@reduxjs/toolkit";
import { Visiable } from "../../../../../utl/models/Visiable";
import { ServiceState } from "../models/ServiceState";

const setMessageVisiable = (state: ServiceState, action: PayloadAction<Visiable>) => {
    state.messageVisiable = action.payload.visiable;
}

export default setMessageVisiable;